import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

const FlagEliminarRegistrosFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Row>
      <Col md={12} className='pt-2'>
        <Field name='flagEliminarRegistros'>
          {({ field }) => (
            <Form.Checkbox
              {...field}
              checked={iValue}
              disabled={fIsSubmitting}
              id='checkbox-flagEliminarRegistros'
              label='Eliminar registros del periodo'
            />
          )}
        </Field>
      </Col>
    </Row>
  )
}

export default React.memo(FlagEliminarRegistrosFormGroup)
